import { FastenerBasePointEnum } from './cutting-custom-hole.model';
import { CuttingFastenersSet } from './cutting-fasteners-set.model';
import { PlateTypeEnum } from './cutting-panel-outline.model';

export class CuttingFixedFastenersSet extends CuttingFastenersSet {
  x: number;
  y: number;
  // clockwise
  basePoint: FastenerBasePointEnum = FastenerBasePointEnum.Start;
  plate: PlateTypeEnum = PlateTypeEnum.Face;
}
